import React from 'react'

function TextItemTittle(props) {
  const { selectedListType, dataItem, changelistItemTitle, dataIndex, editIndexes } = props
  return (
    <>
      {selectedListType !== 'Text' && (
        <div>
          <div>
            {selectedListType} Name:
            {selectedListType === 'Person' ? dataItem.name_En : dataItem.title_En}
          </div>
        </div>
      )}
      {selectedListType === 'Text' && (
        <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
          <div>
            <label>listItemTitle_En:</label>
            <input
              className='form-control'
              style={{ width: '100%' }}
              value={dataItem && dataItem.listItemTitle_En ? dataItem.listItemTitle_En : ''}
              onChange={e => {
                changelistItemTitle(e, dataIndex, 'En')
              }}
              disabled={!editIndexes.includes(dataItem.SK)}
            />
          </div>
          <div>
            <label>listItemTitle_Te:</label>
            <input
              className='form-control'
              style={{ width: '100%' }}
              value={dataItem && dataItem.listItemTitle_Te ? dataItem.listItemTitle_Te : ''}
              onChange={e => {
                changelistItemTitle(e, dataIndex, 'Te')
              }}
              disabled={!editIndexes.includes(dataItem.SK)}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default TextItemTittle
